import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import "./galary.css";

const images = [
  {
    id: "1",
    imageName: "480697859_2048722818873300_1905117411279547834_n.jpg",
    tag: "social",
  },
  {
    id: "144",
    imageName: "a (1).jpeg",
    tag: "social",
  },
  {
    id: "133",
    imageName: "a (2).jpeg",
    tag: "social",
  },
  {
    id: "134",
    imageName: "a (4).jpeg",
    tag: "social",
  },
  {
    id: "135",
    imageName: "a (6).jpeg",
    tag: "social",
  },
  {
    id: "136",
    imageName: "a (7).jpeg",
    tag: "social",
  },
  {
    id: "2",
    imageName: "481300349_2050415638704018_201632224789624624_n.jpg",
    tag: "cultural",
  },
  {
    id: "3",
    imageName: "490004493_2088467798232135_5104312111588048882_n.jpg",
    tag: "celebration",
  },
  {
    id: "5",
    imageName: "490360741_2089751138103801_3904418123417527519_n.jpg",
    tag: "social",
  },
  {
    id: "6",
    imageName: "490500403_2089570548121860_5750332732600230917_n.jpg",
    tag: "cultural",
  },
  {
    id: "9",
    imageName: "490531835_2089751118103803_3996585292482257377_n.jpg",
    tag: "social",
  },
  {
    id: "10",
    imageName: "490628396_2089701688108746_7799581842298531640_n.jpg",
    tag: "cultural",
  },
  {
    id: "13",
    imageName: "DSC_0086.JPG",
    tag: "social",
  },
  { id: "17", imageName: "DSC_0004.JPG", tag: "social" },
  { id: "19", imageName: "DSC_0024.JPG", tag: "celebration" },

  {
    id: "20",
    imageName: "481047677_2049414292137486_6396255060755539121_n.jpg",
    tag: "news",
  },
  {
    id: "21",
    imageName: "481076726_2050426475369601_6415716403700044015_n.jpg",
    tag: "news",
  },
  {
    id: "22",
    imageName: "481307151_2055979504814298_7440327072385146480_n.jpg",
    tag: "news",
  },
  {
    id: "23",
    imageName: "481047677_2049414292137486_6396255060755539121_n.jpg",
    tag: "news",
  },
  {
    id: "24",
    imageName: "482002826_2055979388147643_911331521307732152_n.jpg",
    tag: "news",
  },
];

const Gallery = () => {
  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  // Filter images based on tag
  useEffect(() => {
    tag === "all"
      ? setFilteredImages(images)
      : setFilteredImages(images.filter((image) => image.tag === tag));
  }, [tag]);

  // Open the modal with the selected image
  const openImageModal = (imageName, index) => {
    setSelectedImage(imageName);
    setCurrentIndex(index);
    setShowModal(true);
  };

  // Navigate to previous image
  const prevImage = () => {
    const newIndex =
      (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(`/satkar/${filteredImages[newIndex].imageName}`);
  };

  // Navigate to next image
  const nextImage = () => {
    const newIndex = (currentIndex + 1) % filteredImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(`/satkar/${filteredImages[newIndex].imageName}`);
  };

  // Available gallery tags
  const tags = ["all", "social", "cultural", "news"];

  return (
    <Container className="gallery-container py-5">
      <div className="text-center mb-5">
        <h2 className="fw-bold">Gallery</h2>
        <div className="mx-auto"></div>
      </div>
      {/* Filter Buttons */}
      <div className="filter-buttons mb-4 text-center">
        <div className="d-flex justify-content-center flex-wrap">
          {tags.map((tagName) => (
            <Button
              key={tagName}
              variant={tag === tagName ? "danger" : "outline-danger"}
              className="mx-2 mb-2 text-uppercase filter-btn"
              onClick={() => setTag(tagName)}
            >
              {tagName}
            </Button>
          ))}
        </div>
      </div>

      {/* Gallery Grid */}
      <Row className="gallery-grid g-4">
        {filteredImages.map((image, index) => (
          <Col
            key={image.id}
            xs={12}
            sm={6}
            md={4}
            lg={3}
            className="gallery-item"
          >
            <div
              className="image-card"
              onClick={() =>
                openImageModal(`/satkar/${image.imageName}`, index)
              }
            >
              <img
                src={`/satkar/${image.imageName}`}
                alt={`Gallery image ${image.id}`}
                className="gallery-image"
              />
              <div className="image-overlay">
                <div className="tag-badge">{image.tag}</div>
                <div className="view-icon">
                  <i className="fas fa-search-plus"></i>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>

      {/* Image Modal/Lightbox */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        dialogClassName="gallery-modal"
        size="lg"
      >
        <Modal.Body className="p-0 position-relative">
          <Button
            variant="light"
            className="modal-close-btn"
            onClick={() => setShowModal(false)}
          >
            <i className="fas fa-times"></i>
          </Button>

          <div className="modal-navigation">
            <Button
              variant="light"
              className="nav-btn prev-btn"
              onClick={prevImage}
            >
              <i className="fas fa-chevron-left"></i>
            </Button>

            <Button
              variant="light"
              className="nav-btn next-btn"
              onClick={nextImage}
            >
              <i className="fas fa-chevron-right"></i>
            </Button>
          </div>

          <img
            src={selectedImage}
            alt="Selected gallery image"
            className="img-fluid modal-image"
          />

          <div className="image-counter">
            {currentIndex + 1} / {filteredImages.length}
          </div>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Gallery;
